import { useState } from "react";
import ProposalButtons from "../../Ui/ProposalButton";
import { ProposalBottom, ServicesOptions } from "./styles";

interface SelecionaTipoDemandaProps {
  setTitulo: (titulo: string) => void;
  setTipo: (tipo: string) => void;
}

export default function SelecionaTipoDemanda({
  setTitulo,
  setTipo,
}: SelecionaTipoDemandaProps) {
  const [tipoSelecionado, setTipoSelecionado] = useState<string>("Audiência");

  const opcoes: { [key: string]: string[] } = {
    Audiência: [
      "Audiência Cível",
      "Audiência Penal",
      "Audiência Trabalhista",
      "Outras Audiências",
    ],
    Diligência: [
      "Acompanhamento de atos oficiais",
      "Comparecimento em cartório",
      "Confirmação de endereço",
      "Cópia integral",
      "Cópia parcial",
      "Despacho",
      "Emissão de guia",
      "Retirada de ofício e alvará",
      "Penal",
      "Outras Diligências",
    ],
    Petição: [
      "Alta Complexidade",
      "Baixa Complexidade",
      "Cálculo Simples",
      "Contestação",
      "Estratégia Processual Simples",
      "Inicial",
      "Penal",
      "Recursos",
      "Requerimento Administrativo",
      "Outras Petições",
    ],
    Protocolo: [
      "Acautelamento",
      "Penal",
      "Protocolo eletrônico",
      "Protocolo físico",
      "Protocolo postal",
    ],
    Outros: [
      "Localização de veículo",
      "Outro serviço",
    ],
  };

  return (
    <div style={{ width: "100%", maxWidth: 720, margin: "0 auto" }}>
      <ProposalButtons
        tipos={Object.keys(opcoes)}
        selected={tipoSelecionado}
        setSelected={setTipoSelecionado}
      />

      <ProposalBottom>
        {opcoes[tipoSelecionado].map((opcao) => (
          <ServicesOptions key={opcao}>
            {opcao}
            <div
              className="select"
              onClick={() => {
                setTitulo(opcao);
                setTipo(tipoSelecionado);
              }}
            >
              Selecionar
            </div>
          </ServicesOptions>
        ))}
      </ProposalBottom>
    </div>
  );
}
